import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { leagueIds, sportIds } from 'src/constants/personalizationIds'
import { videos } from 'src/constants/videos'
import { useIsFuboSportsAvailable } from 'src/modules/hooks/useIsFuboSportsAvailable'
import { getFuboSportsCBBPlans } from 'src/constants/planData/fuboSportsCBBPlans'

export default (props) => {
  const { isAvailable } = useIsFuboSportsAvailable()

  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      video={videos.womens_basketball.videoUrl}
      title="Watch women's basketball with Fubo"
      subtitle="Catch the action live all season long"
      networkSet="womensBasketball"
      league="WNBA"
      showRSN={true}
      sportId={sportIds.Basketball}
      leagueId={leagueIds.WNBA}
      matchtickerSportId={sportIds.Basketball}
      matchtickerLeagueName="WNBA"
      matchtickerLeagueId={leagueIds.WNBA}
      hasPlanCards={isAvailable}
      plans={isAvailable ? getFuboSportsCBBPlans() : []}
    />
  )
}
